import React from "react";
import arrowUp from "@assets/random/arrowup.png";
import arrowDown from "@assets/random/arrowdown.png";
import minimizeIcon from "@assets/random/minimize.png";
import maximizeIcon from "@assets/random/maximize.png";
import "./mapComponent.less";
import "../list.less";

const ListSerieNameHeader = ({
   handleMapHeight,
   selectedSerieObj,
   showMap,
   headerPosition,
   toggleMap
}) => {
   return (
      <div
         style={{ cursor: "pointer" }}
         className={"additional-header bottom-map-list-header p2"}
         onClick={handleMapHeight}
      >
         {selectedSerieObj.name}
         {showMap === true ? (
            <>
               <div className="arrow-icon">
                  <img
                     src={
                        headerPosition === "bottom"
                           ? arrowUp
                           : headerPosition === "center"
                           ? arrowDown
                           : null
                     }
                     className="hide-map-icon-img"
                  ></img>
               </div>
               <div className="hide-map-icon" onClick={toggleMap}>
                  <img
                     src={headerPosition === "top" ? minimizeIcon : maximizeIcon}
                     className="hide-map-icon-img"
                  ></img>
               </div>
            </>
         ) : null}
      </div>
   );
};

export default ListSerieNameHeader;
